<template>
  <div v-show="feature" ref="el" class="map-popup">
    <template v-if="feature">
      <TeaserQuarter
        v-if="feature.url"
        :key="feature.id"
        :media="feature.media"
        :title="feature.title"
        :url="feature.url"
      />
      <div v-if="feature.address" class="map-popup-address">
        <AddressText :address="feature.address.address" />
        <AddressLinks :address="feature.address" />
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { MapPoiFeature } from '~/helpers/maps'

defineProps<{
  feature?: MapPoiFeature | null
}>()

const el = ref<HTMLDivElement>()

function getElement(): HTMLDivElement | null | undefined {
  return el.value
}

defineExpose({ getElement })
</script>

<style>
@reference '~/assets/css/tailwind.css';
.map-popup {
  width: 20rem;
  font-size: 1rem;
}

.teaser + .map-popup-address {
  [itemprop='description'] {
    @apply hidden;
  }
}

.map-popup-address {
  @apply bg-background;
  [itemprop='description'] {
    @apply font-bold;
  }
  .address-links {
    @apply mt-size-5;
    font-size: 1rem;
  }
}

.leaflet-fade-anim .leaflet-popup {
  transition: none !important;
}
</style>
